module.exports = __webpack_public_path__ + "static/img/13f.996890b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/13f.jpg
// module id = UW5n
// module chunks = 0